'use client';

import MiniGameContainer from './_components';

export default function MiniGamePage() {
  return <MiniGameContainer />;
}
